import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  imports: [RouterLinkActive, RouterLink, NgClass, MatIcon, NgIf],
})
export class NavigationItemComponent {
  @Input() link!: string;
  @Input() iconName!: string;
  @Input() title!: string;
  @Input() isExpanded = false;

  @Output() preRedirect = new EventEmitter();
}
